const style = {
  box: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    px: 3,
    py: 2,
  },
  cardAction: {
    alignItems: 'center',
    display: 'flex',
  },
  avatar: {
    color: 'success.main',
    height: 36,
    width: 36,
  },
} as const;

export default style;
